









































import { Component, Vue, Prop } from "vue-property-decorator";
import { SubProject } from "../models/subProject";
import dateFlip from "shared/filters/dateflip";
import money from "shared/filters/money";
import moment from "moment";

@Component({
  filters: { dateFlip },
})
export default class SubProjectBlock extends Vue {
  @Prop({ required: true, type: Object }) public value!: SubProject;
  @Prop({ required: true, type: Number }) public projectId!: number;

  get current(): boolean {
    if (moment(this.value.start_date).isAfter()) {
      return false;
    }

    if (this.value.end_date === "") return true;
    if (moment(this.value.end_date).isAfter()) {
      return true;
    }

    return false;
  }

  get period(): string {
    const end =
      this.value.end_date === "" ? "Heden" : dateFlip(this.value.end_date);
    return dateFlip(this.value.start_date) + " - " + end;
  }

  get leaseSum(): string {
    return money(this.value.lease_sum);
  }

  get deposit(): string {
    return money(this.value.deposit);
  }

  private t(key: string): string {
    return this.$t("houseprojects.subProjectBlock." + key).toString();
  }
}
